import TabSelection from "../../components/SelectContent/TabSelection";
import { setFsrAdminTab } from "../../state/slices/generalSlice";

import AllFsrSection from "./AllFsrSection";
import TermDateSection from "./TermDateSection";
import CourseSection from "./CourseSection";
import OverloadCalculatorSection from "./OverloadCalculatorSection";

import {
  FileTextOutlined,
  CalendarOutlined,
  BookOutlined,
  CalculatorOutlined,
} from "@ant-design/icons";

const FsrAdminPage = () => {
  const menuItems = [
    {
      key: "all-fsr",
      label: "All Faculty Service Record",
      component: <AllFsrSection />,
      icon: <FileTextOutlined />,
    },
    {
      key: "term-dates",
      label: "Term Dates",
      component: <TermDateSection />,
      icon: <CalendarOutlined />,
    },
    {
      key: "courses",
      label: "Courses",
      component: <CourseSection />,
      icon: <BookOutlined />,
    },
    {
      key: "calculator",
      label: "Calculator",
      component: <OverloadCalculatorSection />,
      icon: <CalculatorOutlined />,
    },
  ];

  return (
    <TabSelection
      menuItems={menuItems}
      currentTabKey="fsrAdminCurrentTab"
      setTabAction={setFsrAdminTab}
    />
  );
};

export default FsrAdminPage;
